import React, { FC } from 'react';
import s from './artistCard.module.scss';
import { ArtistAvatar } from '@components/UIKit/ArtistAvatar/ArtistAvatar';
import { SocialManagerView } from '@specs/views';
import { Button } from '@components/UIKit/Button/Button';
import { useTranslation } from '@hooks/useTranslation';
import { useRouter } from 'next/router';
import { LinksEnum } from '@specs/navigation';
import { ArtistToysSlider } from '@components/Pages/ArtistsPage/ArtistToysSlider/ArtistToysSlider';
import parse from 'html-react-parser';
import { useMediaQuery } from '@hooks/useMediaQuery';
type ArtistCardProps = {
  data: SocialManagerView.publicProfile;
};
export const ArtistCardBig: FC<ArtistCardProps> = ({
  data
}) => {
  const {
    shortid,
    description
  } = data;
  const isMobile = useMediaQuery('(max-width: 768px)');
  const {
    translate: tr
  } = useTranslation();
  const router = useRouter();
  const goToUser = async () => {
    await router.push({
      pathname: LinksEnum.USER,
      query: {
        slug: shortid
      }
    });
  };
  return <div className={s.artistCardBig} data-sentry-component="ArtistCardBig" data-sentry-source-file="ArtistCardBig.tsx">
            <div className={s.artistCardBig__left}>
                <div className={s.artistCardBig__avatar}>
                    <ArtistAvatar shortId={shortid} srcSet={[{
          height: 100,
          width: 100,
          minMedia: 0
        }]} data-sentry-element="ArtistAvatar" data-sentry-source-file="ArtistCardBig.tsx" />
                </div>

                <div className={s.artistCardBig__info}>
                    <b className={s.artistCardBig__name}>
                        {shortid}
                    </b>
                    <span className={s.artistCardBig__description}>
                        {parse(description ?? '')}
                    </span>
                </div>
                <Button id="go_to_artist_artist_big_card_button" className={s.artistCardBig__button} onClick={goToUser} size='large' color='Black' data-sentry-element="Button" data-sentry-source-file="ArtistCardBig.tsx">
                    {tr({
          id: 'btn.go.to.author'
        })}
                </Button>
            </div>

            <div className={s.artistCardBig__top}>
                <div className={s.artistCardBig__top__avatar}>
                    <ArtistAvatar shortId={shortid} srcSet={[{
          height: 100,
          width: 100,
          minMedia: 0
        }]} data-sentry-element="ArtistAvatar" data-sentry-source-file="ArtistCardBig.tsx" />
                </div>

                <b className={s.artistCardBig__top__name}>
                    {shortid}
                </b>
            </div>

            <ArtistToysSlider artistId={data.artistProfile?.id} data-sentry-element="ArtistToysSlider" data-sentry-source-file="ArtistCardBig.tsx" />

            <span className={s.artistCardBig__descriptionMobile}>
                {parse(description ?? '')}
            </span>

            {isMobile && <Button id="go_to_artist_artist_big_card_button" className={s.artistCardBig__buttonMobile} onClick={goToUser} size='medium' color='Black'>
                {tr({
        id: 'btn.go.to.author'
      })}
            </Button>}
        </div>;
};